import { WeeklyTradingReportFilter } from "../types";
import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

export const getWeeklyTradingDataExcel = (
  user: User,
  filter: WeeklyTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getweeklytradingxls",
    params: {
      userid: user.userId,
      numofweeks: filter.numofweeks,
    },
  });
};

export default getWeeklyTradingDataExcel;
